import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription, combineLatest } from 'rxjs';

import { AppState } from 'src/app/store/app.reducer';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { User } from 'src/app/model/user';
import { Device } from 'src/app/model/device';
import { DeviceModel } from 'src/app/model/device-model';
import { DeviceInfo } from 'src/app/model/device-info';
import { DeviceStatus } from 'src/app/model/device-status';

import { selectUser } from 'src/app/store/user/user.selector';
import { selectCurrentDevice, selectCurrentDeviceModel, selectCurrentDeviceInfo, selectCurrentDeviceStatus } from 'src/app/store/device/device.selector';
import { DeviceCategories } from 'src/app/conf/device-categories';
import { Site } from 'src/app/model/site';
import { selectCurrentSite } from 'src/app/store/site/site.selector';
import * as SiteActions from 'src/app/store/site/site.actions';


@Component({
  selector: 'app-device-tab-info',
  templateUrl: './device-tab-info.component.html',
  providers: [],
})
export class DeviceTabInfoComponent implements OnInit, OnDestroy {
  // Observables and subscriptions
  user$: Observable<User | undefined>;
  userSub: Subscription | undefined;
  device$: Observable<Device | undefined>;
  deviceModel$: Observable<DeviceModel | undefined>;
  deviceModelSub: Subscription | undefined;
  deviceInfo$: Observable<DeviceInfo | undefined>;
  deviceInfoSub: Subscription | undefined;
  deviceStatus$: Observable<DeviceStatus | undefined>;
  deviceStatusSub: Subscription | undefined;
  dataSub: Subscription | undefined;
  site$: Observable<Site | undefined>;

  navItems = [];

  user: User;
  device: Device;
  deviceModel: DeviceModel;
  deviceInfo: DeviceInfo;
  deviceStatus: DeviceStatus;

  categoryName: string;

  getSite: boolean;

  constructor(
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private translate: TranslateService,
  ) {
    this.initSelectors();
  }

  ngOnInit(): void {
    this.getSite = false;
    this.subscribeAll();
  }

  initSelectors(): void {
    // Store selectors
    this.user$ = this.store.select(selectUser);
    this.device$ = this.store.select(selectCurrentDevice);
    this.deviceModel$ = this.store.select(selectCurrentDeviceModel);
    this.deviceInfo$ = this.store.select(selectCurrentDeviceInfo);
    this.deviceStatus$ = this.store.select(selectCurrentDeviceStatus);
    this.site$ = this.store.select(selectCurrentSite);
  }

  subscribeAll(): void {
    this.userSub = this.user$?.subscribe(
      (user) => {
        this.user = user;
      }
    );
    this.deviceModelSub = this.deviceModel$?.subscribe(
      (deviceModel) => {
        this.deviceModel = deviceModel;
      }
    );
    this.deviceInfoSub = this.deviceInfo$?.subscribe(
      (deviceInfo) => {
        this.deviceInfo = deviceInfo;
      }
    );
    this.deviceStatusSub = this.deviceStatus$?.subscribe(
      (deviceStatus) => {
        this.deviceStatus = deviceStatus;
      }
    );
    this.dataSub = combineLatest([
      this.device$,
      this.site$
    ]).subscribe(([currentDevice, currentSite]) => {
      this.device = currentDevice;
      if (currentDevice !== undefined && currentDevice !== null && !this.getSite) {
        this.getSite = true;
        this.store.dispatch(SiteActions.getSite({ siteId: currentDevice.SiteId }));
      }

      if (currentDevice && currentSite) {
        if (currentDevice !== undefined && currentDevice !== null) {
          this.categoryName = DeviceCategories.find(dc => dc.Id === currentDevice.CategoryId)?.Name;
        } else {
          this.categoryName = '';
        }
        this.buildBreadcrumb(currentSite.Devices);
      }
    });
  }

  buildBreadcrumb(devices: Device[]): void {
    this.navItems = [];
    if (this.device.RootId) {
      const rootDevice = devices.find(d => d.Id === this.device.RootId);
      if (rootDevice) {
        this.navItems.push({ label: rootDevice.Name, routerLink: `../${rootDevice.Id}`, disabled: true });
      }
    }
    if (this.device.ParentId !== this.device.RootId) {
      const parentDevice = devices.find(d => d.Id === this.device.ParentId);
      if (parentDevice) {
        this.navItems.push({ label: parentDevice.Name, routerLink: `../${parentDevice.Id}`, disabled: true });
      }
    }
  }

  ngOnDestroy(): void {
    this.dataSub?.unsubscribe();
    this.userSub?.unsubscribe();
    this.deviceModelSub?.unsubscribe();
    this.deviceInfoSub?.unsubscribe();
    this.deviceStatusSub?.unsubscribe();
  }

}
